import Vue from 'vue'
import './setup/vue-composition-api'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import i18n from './setup/i18n'
import communique from './notification'
import './setup/_base'
import './setup/fonts'
import './setup/meta'
import './setup/v-click-outside'
import './setup/vue-multiselect'
import './setup/vee-validate'
import './setup/vue-awesome-swiper'
import './setup/vue-observe-visibility'
import './setup/vue-good-table'
import './registerServiceWorker'
import './index.css'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  communique,
  render: (h) => h(App),
}).$mount('#app')
